import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SessionsServiceApi } from './sessions.service.api';
import { SessionsServiceMock } from './sessions.service.mock';

export interface Session {
  claims: {
    [key: string]: unknown;
  };
  token: string;
  userId: string;
}

export type SessionProvider = 'apple' | 'email' | 'google';

export interface SendEmailVerificationData {
  origin?: string;
  redirectTo?: string;
}

export interface SendPasswordRecoveryData {
  email: string;
}

@Injectable({
  providedIn: 'root',
  useClass: environment.usingMocks ? SessionsServiceMock : SessionsServiceApi,
})
export abstract class SessionsService {
  abstract getAccessToken(): Promise<string | null>;
  abstract getRedirectResult(recaptchaTokenGenerator: () => Promise<string>): Promise<void>;
  abstract getSession(): Observable<Session | null>;
  abstract onSignIn(): EventEmitter<void>;
  abstract onSignOut(): EventEmitter<void>;
  abstract sendEmailVerification(data: SendEmailVerificationData): Promise<void>;
  abstract sendPasswordRecovery(data: SendPasswordRecoveryData): Promise<void>;
  abstract signInWithEmail(data: { email: string; password: string; }, recaptchaTokenGenerator: () => Promise<string>): Promise<void>;
  abstract signInWithProvider(provider: 'apple' | 'google', recaptchaTokenGenerator: () => Promise<string>): Promise<void>;
  abstract signOut(): Promise<void>;
  abstract signUpWithEmail(data: { email: string; password: string; }, recaptchaTokenGenerator: () => Promise<string>): Promise<void>;
  abstract updatePassword(password: string, token: string): Promise<void>;
  abstract verifyEmail(token: string): Promise<{ origin?: string; redirectTo: string; } | null>;
  abstract verifyPasswordResetCode(code: string): Promise<void>;
}
